import "./Photos.css"

import { useState } from 'react';

function Photos(prop) {

    const [imageNum, setImageNum] = useState(0);
    const [imageStr, setImageStr] = useState(prop.photosArr[0]);


    function next() {
        let num = imageNum + 1;
        num = num % prop.photosArr.length;
        setImageNum(num);
        setImageStr(prop.photosArr[num])
    }

    function back() {
        let num = imageNum - 1;
        if (num < 0) {
            num = prop.photosArr.length-1;
        }
        setImageNum(num);
        setImageStr(prop.photosArr[num])
    }

    return (
        <div className="Photos">
            <div className="PhotoContainer">
            {imageStr.includes("http") ? (
                <iframe src={imageStr} frameBorder='0' allow='autoplay; encrypted-media' allowFullScreen title='video'> </iframe>
            ) : (
                <img src={require("./Resources/" + imageStr)} alt={imageStr} />
            )}
            </div>
            <button onClick={back}>Previous</button>
            <button onClick={next}>Next</button>
        </div>

    );
}

export default Photos;
